import React, { useEffect, useRef } from "react";
import type RealtimeKitClient from "@cloudflare/realtimekit";
import { RtkMeeting, provideRtkDesignSystem } from "@cloudflare/realtimekit-react-ui";

// Inicializa o design system uma vez.
if (typeof document !== "undefined") {
  provideRtkDesignSystem(document.documentElement, { theme: "dark" });
}

interface DyteMeetProps {
  meeting: RealtimeKitClient;
  /**
   * Encaminha o evento `roomLeft` do Dyte com o `state` original
   * ('left' | 'ended' | 'kicked' | 'rejected' | 'disconnected' | 'failed' ...).
   * Quem decide o que fazer (encerrar x reconectar) é o Room, que distingue
   * saída legítima de queda de rede para não derrubar a sala de todos.
   */
  onMeetingEnd?: (state?: string) => void;
}

const DyteMeet: React.FC<DyteMeetProps> = ({ meeting, onMeetingEnd }) => {
  const meetingEl = useRef<HTMLRtkMeetingElement>(null);

  useEffect(() => {
    const handleRoomLeft = ({ state }: { state?: string }) => {
      onMeetingEnd?.(state);
    };

    meeting.self.on("roomLeft", handleRoomLeft);

    return () => {
      meeting.self.removeListener("roomLeft", handleRoomLeft);

      // Remover listeners de stageStatusUpdate que causam memory leak.
      if (meeting.stage && typeof meeting.stage.removeAllListeners === "function") {
        meeting.stage.removeAllListeners("stageStatusUpdate");
      }
    };
  }, [meeting, onMeetingEnd]);

  return (
    <div className="h-full w-full relative">
      <RtkMeeting
        meeting={meeting}
        ref={meetingEl}
        showSetupScreen={false}
        className="w-full h-full"
        leaveOnUnmount={true}
        mode="fill"
      />
    </div>
  );
};

export default DyteMeet;
